import { tGlobal } from '../services/translation';
import { Button } from './buttons/button';
import { Dialog, DialogContent, DialogFooter, DialogTitle } from './dialog';

type ModalSignOutProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSignOut: () => void;
  title: string;
};

export function ModalSignOut(props: ModalSignOutProps) {
  const { open, onOpenChange, title, onSignOut } = props;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hasCloseButton>
        <DialogTitle align="center">{title}</DialogTitle>
        <DialogFooter>
          <Button
            size="xl"
            variant="outline"
            className="w-full"
            onClick={function () {
              void onOpenChange(false);
            }}
          >
            {tGlobal('nevermind')}
          </Button>
          <Button
            size="xl"
            variant="destructive"
            className="w-full"
            onClick={function () {
              onSignOut();
            }}
          >
            {tGlobal('logout')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
